import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {SessionService} from "../../session/session.service";
import {NavigationEnd, Router, RoutesRecognized} from "@angular/router";
import {UntypedFormBuilder, UntypedFormGroup} from "@angular/forms";
import {SearchService} from "../../services/search.service";
import {Observable} from "rxjs";
import {map} from "rxjs/operators";
import {MatDrawer} from "@angular/material/sidenav";
import {Usuario} from "../../model/personas/usuario.model";
import {Persona} from "../../model/personas/persona.model";
import * as moment from "moment";
import {ConversacionesService} from "../../pages/mensajes/conversaciones.service";
import {puedeUsarMensajes} from "../../pages/mensajes/acceso-mensajes";
import {ComunicadosAvisoService} from "../../pages/mensajes/comunicados-aviso/comunicados-aviso.service";

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
    title = '';
    public searchGroup: UntypedFormGroup;
    public displayClock = false;
    public clock = null;
    public profileClock = '';
    public readonly noLeidas$: Observable<number>;

    @Input() public drawer: MatDrawer;
    @Input() public isHandset$: Observable<boolean>;
    @Input() public menuAvailable: boolean;
    @Input() public mostrarToolBar: boolean;

    public get profileName(): string {
        const profile = this.sessionService.profile;
        if (profile instanceof Usuario) {
            return profile.username;
        } else if (profile instanceof Persona) {
            return profile.nombreCompleto;
        }
        return '';
    }

    public get sessionMinutesLeft(): number {
        return this.sessionService.isLogged() ?
            this.sessionService.token.expiration.diff(moment(), 'm') :
            Infinity;
    }

    private _clockInterval;

    constructor(fb: UntypedFormBuilder,
                public searchService: SearchService,
                public sessionService: SessionService,
                private _router: Router,
                private _conversaciones: ConversacionesService,
                private _comunicadosAviso: ComunicadosAvisoService) {
        this.noLeidas$ = this._conversaciones.resumen$.pipe(map(r => r.noLeidas ?? 0));
        this._router.events.subscribe(data => {
            if (data instanceof RoutesRecognized) {
                let title = data.state.root.firstChild.data['title'];
                this.displayClock = !!data.state.root.firstChild.data['displayClock'];
                if (title) {
                    this.title = title;
                } else {
                    title = data.state.root.children[0]?.children[0]?.data['title'];
                    if (title) {
                        this.title = title;
                    } else {
                        this.title = '';
                    }
                }
            }
            if (data instanceof NavigationEnd && this.mensajes) {
                this._conversaciones.refrescarResumen();
            }
        });

        this.searchGroup = fb.group({search: ''});
        searchService.search.subscribe(s => this.searchGroup.controls['search'].setValue(s, {emitEvent: false}));
        this.searchGroup.controls['search'].valueChanges
            .subscribe(v => searchService.currentSearch = v);
    }

    public logout() {
        this.sessionService.logout();
        this._router.navigateByUrl('/');
        window.location.reload();

    }

    /** Si la sesión tiene mensajes (grupo Mensajes): sobre, sondeo y avisos. */
    public get mensajes(): boolean {
        return puedeUsarMensajes(this.sessionService);
    }

    ngOnInit() {
        // El perfil llega tras el login sin recargar la página: se mira al arrancar y en cada cambio.
        this._seguirSesionEnMensajes();
        this.sessionService.profileChanges.subscribe(() => this._seguirSesionEnMensajes());
        /* this._clockInterval = setInterval(() => {
             this.clock = moment().format('HH:mm');
             if (this.sessionService.isLogged()) {
                 const diff = this.sessionService.token.expiration.diff(moment(), 's');
                 const duration = moment.duration(diff, 's');
                 let format = 'mm[\'] ss["]';
                 if (duration.asHours() > 1) {
                     format = 'HH[h] mm[\']';
                 }
                 this.profileClock = '- expira en: ' + moment.utc(+duration).format(format);
             } else {
                 this.profileClock = '';
             }
         }, 500);*/
    }

    ngOnDestroy(): void {
        clearInterval(this._clockInterval);
        this._conversaciones.detenerSondeo();
    }

    private _seguirSesionEnMensajes(): void {
        if (this.mensajes) {
            this._conversaciones.iniciarSondeo();
            this._conectarAvisos();
        } else {
            this._conversaciones.detenerSondeo();
        }
    }

    /**
     * El topic del cliente necesita su id, que llega con el perfil (GET /me), no con el token. Es
     * también donde ya hay perfil para el aviso de comunicados al entrar (una vez por carga de la
     * app: ComunicadosAvisoService.revisar() se guarda sola si ya se comprobó).
     */
    private _conectarAvisos(): void {
        const id = (this.sessionService.profile as any)?.id;
        if (this.sessionService.isLogged() && id) {
            this._conversaciones.conectarAvisos(['cliente-' + id], this.sessionService.mercureToken);
            this._comunicadosAviso.revisar();
        }
    }
}
